/**
 * Container component - Responsive page container
 */

import {HTMLAttributes, forwardRef} from 'react';
import {cn} from '../../utils/cn';

interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  padding?: boolean;
}

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({className, size = 'xl', padding = true, ...props}, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'w-full mx-auto',
          {
            'max-w-screen-sm': size === 'sm',
            'max-w-screen-md': size === 'md',
            'max-w-screen-lg': size === 'lg',
            'max-w-screen-xl': size === 'xl',
            'max-w-screen-2xl': size === 'full',
            'px-4 sm:px-6 lg:px-8': padding,
          },
          className
        )}
        {...props}
      />
    );
  }
);

Container.displayName = 'Container';

